<script setup lang="ts">

import {useStoreSnackbar} from "~/store";
import {useDisplay} from "vuetify";

const store = useStoreSnackbar()

const {xs} = useDisplay()

const icon = computed(() => {
  switch (store.color) {
    case 'error':
      return {
        name: 'core-warning-outlines',
        color: 'warning'
      }
    case 'warning':
      return {
        name: 'core-warning-outlines',
        color: 'warning'
      }
    case 'success':
      return {
        name: 'core-equipments',
        color: 'primary'
      }
    default:
      return {
        name: 'core-warning-outlines',
        color: 'warning'
      }
  }
})

const close = () => {
  store.snackbar = false
}

</script>

<template>
  <ui-custom-modal v-model:visible="store.snackbar" persistent :closable="false" z-index="99999">
    <div class="snackbar-content" :class="{'snackbar-content--desktop': !xs}">
      <ui-custom-icon :icon="icon.name" :color="icon.color" :size="40"/>
      <span class="snackbar-text">
        {{ store.message }}
      </span>
      <ui-custom-button :color="'outline-transparent'" :size="'xl'" :width="'11.25rem'" class="snackbar-button"
                        @click="close">
        Ок
      </ui-custom-button>
    </div>
  </ui-custom-modal>
</template>

<style scoped lang="scss">
@use 'assets/css/tokens/colors' as *;
@use 'assets/css/tokens/typography' as *;

.snackbar-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .75rem;

  &--desktop {
    padding: 2rem 1.25rem;
    min-width: 390px;
    max-width: 450px;
  }
}

.snackbar-text {
  font-size: $font-size-18;
  line-height: $line-height-22;
  font-weight: $font-weight-medium;
  color: $color-dark;
  text-align: center;
}

.snackbar-button {
  margin-top: 1.5rem;
}
</style>